module.exports = __webpack_public_path__ + "static/media/thank-you-bottom-img.bf7f5e64.jpg";